import { savedOrderDetailsActionButtonsStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsActionButtons";
import { savedOrderDetailsCartLineStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsCartLine";
import { savedOrderDetailsHeaderStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsHeader";
import { savedOrderDetailsOrderInformationStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsOrderInformation";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getProp from "@insite/mobius/utilities/getProp";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

savedOrderDetailsActionButtonsStyles.deleteButton = {
    mergeCss: true,
    css: css`
        margin-left: 10px;
    `,
    buttonType: "outline",
    variant: "secondary",
};

savedOrderDetailsActionButtonsStyles.addToListButton = {
    mergeCss: true,
    css: css`
        margin-left: 10px;
    `,
    buttonType: "outline",
    variant: "secondary",
};

savedOrderDetailsActionButtonsStyles.placeOrderButton = {
    mergeCss: true,
    css: css`
        margin-left: 10px;
    `,
};

savedOrderDetailsActionButtonsStyles.narrowOverflowMenu = {
    cssOverrides: {
        wrapper: css`
            margin-left: 20px;
            button {
                min-width: 100%;
                &:hover {
                    border: none !important;
                    background: none !important;
                }
                &:focus {
                    outline: none !important;
                }
            }
        `,
    },
};

savedOrderDetailsHeaderStyles.titleGridItem = {
    width: [10, 10, 7, 4, 4],
    css: css`
        h1 {
            font-size: 37px;
        }
    `,
};

savedOrderDetailsOrderInformationStyles.orderInformationGridContainer = {
    gap: 15,
    css: css`
        margin-top: 10px !important;
        h3 {
            font-size: ${TYPOGRAPHY.size.base};
        }
    `,
};

savedOrderDetailsCartLineStyles.productPartNumbersGridItem = {
    css: css`
        span {
            &:first-child {
                color: ${getProp("theme.typography.p.color")} !important;
            }
        }
    `,
    width: 12,
};

savedOrderDetailsCartLineStyles.priceGridItem = {
    width: [12, 12, 12, 4, 4],
    printWidth: 4,
    css: css`
        flex-direction: column;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css``,
                css``,
                css``,
                css`
                    flex-basis: 60% !important;
                    max-width: 60% !important;
                `,
                null,
            ])}
        h4 {
            font-size: ${TYPOGRAPHY.size.base};
        }
    `,
};

savedOrderDetailsCartLineStyles.extendedUnitNetPriceGridItem = {
    width: [4, 4, 4, 3, 3],
    css: css`
        flex-direction: column;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css``,
                css``,
                css``,
                css`
                    flex-basis: 22% !important;
                    max-width: 22% !important;
                `,
                null,
            ])}
    `,
};

savedOrderDetailsCartLineStyles.savedOrderLineCardAddToListGridItem = {
    width: [6, 6, 6, 4, 4],
    printWidth: 0,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css``,
                css``,
                css``,
                css`
                    flex-basis: 30% !important;
                    max-width: 30% !important;
                `,
                null,
            ])}
    `,
};

savedOrderDetailsCartLineStyles.quantityGridItem = {
    width: [2, 2, 2, 1, 1],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css``,
                css``,
                css``,
                css`
                    flex-basis: 9.3333% !important;
                    max-width: 9.3333% !important;
                `,
                null,
            ])}
    `,
};
